import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProcessTaskCenterService } from './ProcessTaskCenterService';

@Injectable({ providedIn: 'root' })
export class TaskCenterNotificationService {
  private pendingCountSubject = new BehaviorSubject<number>(0);
  pendingCount$ = this.pendingCountSubject.asObservable();

  constructor(private processTaskCenterService: ProcessTaskCenterService) { }

  refreshPendingCount(): void {
    this.processTaskCenterService.getSummary().subscribe(
      summary => this.pendingCountSubject.next(this.normalizeCount(summary.ActionRequiredCount)),
      () => this.pendingCountSubject.next(0)
    );
  }

  reset(): void {
    this.pendingCountSubject.next(0);
  }

  private normalizeCount(value: number): number {
    if (typeof value !== 'number' || !isFinite(value) || value < 0) {
      return 0;
    }

    return Math.floor(value);
  }

}
